<template>
  <v-card class="mb-4 app">
    <snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-container>
      <v-row class="board">
        <v-col cols="9">
          <Container
            @click="handleDragStart('valoresDisponiveisComboBox', $event)"
            :get-child-payload="getChildPayload"
            :drop-placeholder="{ class: 'placeholder' }"
          >
            <v-select
              class="mt-5"
              multiple
              v-model="selecinadoComboBox"
              :items="valoresDisponiveisComboBox"
              item-text="description"
              :label="dragname"
              return-object
              outlined
              dense
            >
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ item.description ? item.description : item }}</span>
                <v-chip v-if="index === 1" small>
                  <span class="caption"> (+{{ selecinadoComboBox.length - 1 }}) </span>
                </v-chip>
              </template>
            </v-select>
            <v-dialog scrollable persistent v-model="dialog">
              <v-card color="background">
                <v-card-title>
                  <span>{{ acaoSelecionada.description }}</span>
                </v-card-title>
                <v-divider />

                <v-card-text>
                  <Dialog
                    :acao="acaoSelecionada"
                    :key="componentKey"
                    @form="updateForm($event)"
                    @error="error($event)"
                  />
                </v-card-text>

                <v-divider />

                <v-card-actions>
                  <v-spacer />
                  <v-btn color="blue darken-1" text @click="dialog = false">Cancelar</v-btn>
                  <v-btn color="blue darken-1" text @click="FormSalvar(acaoSelecionada)">Salvar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </Container>
        </v-col>
        <v-col class="text-right" cols="3">
          <v-btn class="mt-5 mr-4" color="bluePcm" dark @click="insere()">Selecionar</v-btn>
          <v-spacer />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-card outlined>
            <v-list dense color="background">
              <div>
                <v-subheader>{{ dragname.toUpperCase() }}</v-subheader>
                <v-list-item-group v-model="item">
                  <div>
                    <Container
                      :group-name="dragname"
                      @drag-start="handleDragStart('ValoresSelecionadosDrag', $event, ValoresSelecionadosDrag)"
                      @drop="handleDrop('ValoresSelecionadosDrag', $event)"
                      :get-child-payload="getChildPayload"
                      :drop-placeholder="{ class: 'placeholder' }"
                    >
                      <Draggable v-for="(valor, key) in ValoresSelecionadosDrag" :key="key">
                        <Card>
                          <v-list-item three-line>
                            <v-list-item-content @dblclick="atualizar(valor, key)">
                              <v-list-item-title
                                >{{ key + 1 }} - {{ valor.description }} -
                                {{ valor.acao.description }}</v-list-item-title
                              >
                              <v-list-item-subtitle>
                                Regex Origem: {{ valor.regexVisualOrigem }} / Regex Destino:
                                {{ valor.regexVisualDestino }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle>
                                Grupo de Expressões Origem: {{ valor.alliasRegexOrigemDescription }} / Grupo de
                                Expressões Destino: {{ valor.alliasRegexDestinoDescription }}
                              </v-list-item-subtitle>
                              <v-list-item-subtitle>
                                Centro de Custo: {{ descriptionCentroDeCusto[key] }} / Executar Próxima Ação Válida:
                                {{ valor.acao.continuar }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <div v-bind="attrs" v-on="on">
                                  <v-switch dense v-model="valor.active"></v-switch>
                                </div>
                              </template>
                              <span>Ativar/Desativar</span>
                            </v-tooltip>
                            <v-list-item-icon class="mt-7">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    class="mr-2"
                                    color="orangePcm"
                                    @click="atualizar(valor, key)"
                                    v-bind="attrs"
                                    v-on="on"
                                    >mdi-pencil</v-icon
                                  >
                                </template>
                                <span>Atualizar</span>
                              </v-tooltip>

                              <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon color="darkRed" @click="remove(key)" v-bind="attrs" v-on="on"
                                    >mdi-close-circle</v-icon
                                  >
                                </template>
                                <span>Remover</span>
                              </v-tooltip>
                            </v-list-item-icon>
                          </v-list-item>
                          <v-divider class="mx-2" />
                        </Card>
                      </Draggable>
                    </Container>
                  </div>
                </v-list-item-group>
              </div>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { Container, Draggable } from 'vue-smooth-dnd'
import { mapGetters, mapActions } from 'vuex'
import { registerVuexModule } from '@/utils/vuexUtils'
import Snackbar from '@/componentes/Snackbar'
import Card from '@/componentes/Card'
import Dialog from './Dialog'
import rotasStore from '../../../../store'

export default {
  name: 'DraggAndDrop',
  props: {
    dragname: String,
    valoresDisponiveisComboBox: Array,
    opcoesSelecionadas: Array,
  },
  components: { Container, Draggable, Card, Dialog, Snackbar },

  data: () => ({
    item: -1,
    selecinadoComboBox: [],
    ValoresSelecionadosDrag: [],
    dialog: false,
    acaoSelecionada: {},
    keySelecionada: null,
    componentKey: 0,
    form: {},
    descriptionCentroDeCusto: [],
    errorMessage: false,
    text: '',
    snackbar: false,
    centrosDeCusto: [],
    regexes: [],
  }),

  computed: {
    ...mapGetters('draggAndDropAcoesRotasModulePABXStore', ['getCentroDeCustos', 'getRegex']),
  },

  async created() {
    registerVuexModule(this.$store, 'draggAndDropAcoesRotasModulePABXStore', rotasStore)

    await Promise.all([this.listarCentroDeCustos(), this.listarRegex()])

    this.centrosDeCusto = [...this.getCentroDeCustos]
    this.regexes = [...this.getRegex]
  },

  methods: {
    ...mapActions('draggAndDropAcoesRotasModulePABXStore', ['listarCentroDeCustos', 'listarRegex']),

    handleDragStart(lane, dragResult, value) {
      const { payload, isSource } = dragResult
      if (isSource) {
        this.draggingCard = {
          lane,
          index: payload.index,
          cardData: {
            value: value[payload.index],
          },
        }
      }
    },
    handleDrop(lane, dropResult) {
      const { removedIndex, addedIndex } = dropResult
      if (lane === this.draggingCard.lane && removedIndex === addedIndex) {
        return
      }

      let novoValor1 = this.descriptionCentroDeCusto[removedIndex]
      let novoValor2 = this.descriptionCentroDeCusto[addedIndex]

      this.descriptionCentroDeCusto[removedIndex] = novoValor2
      this.descriptionCentroDeCusto[addedIndex] = novoValor1

      if (removedIndex !== null) {
        this.ValoresSelecionadosDrag.splice(removedIndex, 1)
      }

      if (addedIndex !== null) {
        this.ValoresSelecionadosDrag.splice(addedIndex, 0, this.draggingCard.cardData.value)
      }
    },
    insere() {
      this.selecinadoComboBox.forEach(valueSelecionado => {
        this.ValoresSelecionadosDrag.push(Object.assign({}, valueSelecionado))
      })
      // this.selecinadoComboBox = [];
    },
    remove(key) {
      this.valoresDisponiveisComboBox.push(this.ValoresSelecionadosDrag[key])
      this.ValoresSelecionadosDrag.splice(key, 1)
      this.descriptionCentroDeCusto.splice(key, 1)
    },

    atualizar(valor, key) {
      this.componentKey += 1
      this.dialog = true
      this.keySelecionada = key
      this.acaoSelecionada = valor
    },
    getChildPayload(index) {
      return {
        index,
      }
    },
    updateForm(event) {
      this.form = Object.assign({}, event)
    },

    FormSalvar() {
      if (this.form.alliasRegexOrigem == '' && this.form.regexVisualOrigem == '') {
        this.text = 'Favor selecionar ao menos um grupo de expressões de origem ou uma expressão de origem.'
        this.snackbar = true
        return
      } else if (this.form.alliasRegexDestino == '' && this.form.regexVisualDestino == '') {
        this.text = 'Favor selecionar ao menos um grupo de expressões de destino ou uma expressão de destino.'
        this.snackbar = true
        return
      }

      this.errorMessage.$touch()
      if (this.errorMessage.$error) {
        return
      } else {
        this.dialog = false
        this.ValoresSelecionadosDrag.splice(this.keySelecionada, 1, this.form)

        const indexCentrosDeCusto = this.centrosDeCusto.findIndex(
          centroDeCusto => centroDeCusto._id === this.form.acao.centroDeCusto
        )

        if (indexCentrosDeCusto !== -1) {
          this.descriptionCentroDeCusto.splice(
            this.keySelecionada,
            1,
            this.centrosDeCusto[indexCentrosDeCusto].description
          )
        }
      }
    },
    error(error) {
      this.errorMessage = error
    },
  },

  watch: {
    ValoresSelecionadosDrag: {
      deep: true,
      handler(dragnovo) {
        this.$emit('dragUpdate', dragnovo)
        if (dragnovo.length > 0) {
          dragnovo.forEach((drag, key) => {
            if (drag.alliasRegexOrigem) {
              const indexRegexOrigem = this.regexes.findIndex(regex => regex._id === drag.alliasRegexOrigem)

              if (indexRegexOrigem !== -1) {
                drag.alliasRegexOrigemDescription = this.regexes[indexRegexOrigem].description

                if (drag.alliasRegexOrigemDescription !== this.regexes[indexRegexOrigem].description) {
                  this.ValoresSelecionadosDrag.splice(key, 1, drag)
                }
              }
            }

            if (drag.alliasRegexDestino) {
              const indexRegexDestino = this.regexes.findIndex(regex => regex._id === drag.alliasRegexDestino)

              if (indexRegexDestino !== -1) {
                drag.alliasRegexDestinoDescription = this.regexes[indexRegexDestino].description

                if (drag.alliasRegexDestinoDescription !== this.regexes[indexRegexDestino].description) {
                  this.ValoresSelecionadosDrag.splice(key, 1, drag)
                }
              }
            }

            const indexCentrosDeCusto = this.centrosDeCusto.findIndex(
              centroDeCusto => centroDeCusto._id === drag.acao.centroDeCusto
            )

            if (indexCentrosDeCusto !== -1) {
              this.descriptionCentroDeCusto.splice(key, 1, this.centrosDeCusto[indexCentrosDeCusto].description)
            }
          })
        }
      },
    },
    opcoesSelecionadas(novo) {
      let array = []
      novo.forEach(opcao => {
        if (typeof opcao === 'object') {
          array.push(Object.assign({}, opcao))
        } else {
          array.push(opcao)
        }
      })
      this.ValoresSelecionadosDrag = array
    },
  },
}
</script>

<style scoped>
.board {
  display: flex;
  justify-content: flex-start;
}

.lane {
  min-width: 50px;
  min-height: 50px;
  margin: 0 0.8rem;
  padding: 0 0.7rem;
}

.placeholder {
  background: rgba(33, 33, 33, 0.08);
  border-radius: 0.4rem;
  transform: scaleY(0.65);
  transform-origin: 0% 0%;
}
.app {
  background-color: var(--v-background-base);
}
</style>
